import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ModalService } from '@core/services/modal/modal.service';

@Component({
	selector: 'app-delete-modal',
	templateUrl: './delete-modal.component.html',
	styleUrls: ['./delete-modal.component.scss'],
})
export class DeleteModalComponent implements OnInit {
	static readonly ID = crypto.randomUUID();

	constructor(
		private dialogRef: MatDialogRef<DeleteModalComponent>,
		private modalService: ModalService,
	) {}

	ngOnInit() {
		this.modalService.liftUpModal(this.dialogRef);
	}

	close(): void {
		this.dialogRef.close();
	}

	delete(): void {
		this.dialogRef.close(true);
	}
}
